import {Phone} from './register.model';
import {UserProfileAddress} from './user-profile.model';

export interface Session {
  user: SessionUser;
  access_token?: string;
  expires_in?: number;
  patientId?: number;
  refresh_token?: string;
  refresh_expires_in?: number;
  email: string;
  phone: Phone;
  addressDto: UserProfileAddress;
  not_before_policy?: number;
  isFirstTimeLogin?: boolean;
  id_token?: string;
  toursCompleted?: SessionTours;
  preferredInsuranceId?: number;
  launchSynchronization?: boolean;
}

export interface SessionUser {
  id?: number;
  username?: string;
}

export class SessionTours {
  [key: string]: boolean;
}
